import { faFolderPlus, faPenCircle } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { Popup } from "ui/components/Popup"
import { isTabletScreen } from "ui/tools/responsive"
import { IUser } from "user/model"
import { UserForm } from "./UserForm"

interface IUserFormPopupProps {
  allUsers: IUser[]
  userId: number | null
  disableUserEdit?: boolean
  disableUserRole?: boolean
  disableUserPassword?: boolean
  onClose: () => any
  onSave: (user: IUser) => any
  onRoleChange: (user: IUser) => any
}

interface IUserFormPopupConnectProps {
  isTablet: boolean
}

const UserFormPopupFn = React.memo(
  ({
    userId,
    allUsers,
    disableUserEdit,
    disableUserPassword,
    disableUserRole,
    isTablet,
    onClose,
    onSave,
    onRoleChange
  }: IUserFormPopupProps & IUserFormPopupConnectProps) => {
    const isCreation = React.useMemo(() => typeof userId !== "number", [userId])
    const otherUsers = React.useMemo(
      () => (userId === null ? allUsers : allUsers.filter(u => u.id !== userId)),
      [allUsers, userId]
    )
    return (
      <Popup
        icon={isCreation ? faFolderPlus : faPenCircle}
        id="user-form-popup"
        title={translate(isCreation ? "user.add.title" : "user.update.title")}
        onClose={() => onClose()}
        minWidth={isTablet ? "calc(100% - 4rem)" : "45rem"}
        maxWidth={isTablet ? "calc(100% - 4rem)" : "50rem"}
        sx={{
          "& .MuiDialogContent-root": {
            maxWidth: "100%",
            maxHeight: "100%"
          },
          "& h2.MuiDialogTitle-root": { minWidth: 0 },
          "& h2.MuiDialogTitle-root p": { marginRight: "1rem" }
        }}>
        <UserForm
          userId={userId}
          onSave={u => onSave(u)}
          onRoleChange={u => onRoleChange(u)}
          onCancel={() => onClose()}
          otherUsers={otherUsers}
          disableUserEdit={disableUserEdit}
          disableUserPassword={disableUserPassword}
          disableUserRole={disableUserRole}
        />
      </Popup>
    )
  }
)

export const UserFormPopup = connect(
  (state: IRootState): IUserFormPopupConnectProps => ({
    isTablet: isTabletScreen(state)
  })
)(UserFormPopupFn)
